export function Brand({ size = "md", showText = true, className = "" }) {
  const h = size === "lg" ? "h-12" : size === "sm" ? "h-8" : "h-10";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img src="/peca360-logo.svg" alt="Peça360" className={`${h} w-auto object-contain drop-shadow`} />
      {showText && (
        <div className="leading-none">
          <div className="flex items-baseline gap-1.5">
            <div className="font-display font-extrabold tracking-wide text-slate-50 text-xl">PEÇA<span className="text-sky-500">360</span></div>
            <span className="text-[9px] font-mono uppercase tracking-wider text-sky-400">SaaS</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-mono">Almoxarifado da manutenção</div>
        </div>
      )}
    </div>
  );
}
